export default __webpack_public_path__ + "static/media/prev-NDNU-3.b97a59fd.png";